import { connect } from 'react-redux';

import { Creators as StepCreators } from '../../../../services/redux/extendVignetteSteps/actions';
import { Creators } from 'services/redux/buyVignette/actions';
import UploadFile from './components';

const mapStateToProps = state => {
  return {
    isLoading: state.buyVignet.uploadingDocuments,
    error: state.buyVignet.uploadDocumentsError,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateRoute: route => {
      dispatch(StepCreators.updateBuyVignetteRoute(route));
    },
    uploadDocuments: data => {
      dispatch(Creators.buyVignetUploadDocumentsRequest(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
